<template>
    <a target="_blank" :href="order.order_base.url">
        <el-popover
                trigger="hover"
                width="600px"
                placement="right"
                :open-delay="800">
            <el-row style="margin: 5px 2px">
                <el-col :span="24">
                    <el-link target="_blank" :href="order.order_base.url">{{ order.order_base.name }}</el-link>
                </el-col>
            </el-row>
            <el-row>
                <el-image
                        style="width: 200px; height:200px;float: left"
                        :src="order.order_base.image_url"
                        alt="图片"
                        fit="contain">
                </el-image>

                <div style="float: left;padding: 0 15px">
                    <p>上架日期: {{ order.order_base.create_date }}</p>
                    <p>
                        <span>品类: {{ order.order_base.category_display }}</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>颜色: {{ order.color }}</span>
                    </p>
                    <p>
                        库存:
                        <color-number :number="order.order_base.stock_num"></color-number>
                    </p>
                    <p>可用库存:
                        <color-number :number="order.order_base.avai_stock"></color-number>
                    </p>
                    <p>在途:
                        <color-number
                                :number="order.order_base.purchase_on_way"></color-number>
                    </p>
                    <p>近期销量: {{ order.order_base.sale_tract }}</p>
                    <el-divider><i class="el-icon-warning text-warning"></i></el-divider>
                    <p>备注: 以上为最近一次导入<code>旺店通</code>的库存数据，仅参考</p>
                </div>
            </el-row>


            <!-- 触发器 -->
            <el-image
                    style="width: 65px; height: 65px"
                    :src="order.order_base.image_url"
                    alt="图片"
                    slot="reference"
                    fit="contain">
            </el-image>
        </el-popover>
    </a>
</template>

<script>
    import ColorNumber from '../ColorNumber'

    export default {
        name: "ImageCol",
        props: {
            order: Object,
        },
        components: {
            ColorNumber,
        },
    }
</script>

<style scoped>

</style>